const projects = [
  {
    title: 'Hira | حيرة',
    image: '../works/hira.png',
    live: 'https://tryhira.com',
    repository: 'https://github.com/Mofuhidy/hira',
    technology: ['Next.js', 'Supabase', 'AI'],
    shortDescription: 'An AI-powered application to help with daily meal decisions based on available ingredients.',
    description: 'Hira is an AI-powered application designed to solve the daily dilemma of deciding what to eat. It acts as a smart kitchen assistant that takes your available ingredients and generates personalized recipes, saving time, reducing decision fatigue, and minimizing food waste.',
  },
  {
    title: 'Vibecurb',
    image: '../works/vibecurb.png',
    live: 'https://vibecurb.vercel.app/',
    repository: 'https://github.com/Mofuhidy/vibecurb',
    technology: ['AI', 'Security Tooling', 'TypeScript'],
    shortDescription: 'A security tool designed to check for vulnerabilities and flaws in AI-generated code.',
    description: 'Vibecurb is an automated security review tool that acts as a safeguard for developers utilizing AI for code generation. It analyzes AI-generated code snippets to identify potential security vulnerabilities and logical errors before they reach production environments.',
  },
  {
    title: 'Lahza | لحظة',
    image: '../works/lahza.png',
    live: 'https://thmanyah-ai-discovery.vercel.app/',
    repository: 'https://github.com/Mofuhidy/Thmanyah_AI_Discovery',
    technology: ['Next.js', 'AI', 'Semantic Search'],
    shortDescription: 'A semantic search engine built for the podcast archive of Thmanyah.',
    description: 'Lahza is an advanced AI-powered semantic search engine tailored for Thmanyah podcasts. It allows users to search through massive podcast archives using natural language, finding specific topics and moments across hundreds of hours of audio content seamlessly.',
  },

  {
    title: 'Yemen Cargo',
    image: '../works/yemenCargo.jpg',
    live: 'https://yemencargo.com/',
    repository: 'https://github.com/Mofuhidy/yemen-cargo',
    technology: ['HTML', 'CSS', 'JS'],
    shortDescription: 'A website for vieweing the services of Yemen Cargo company',
    description: 'Yemen Cargo is a website for vieweing the services of Yemen Cargo company, it allows the customers to book a cargo and contact with them.',
  }, {
    title: 'Budget Beam',
    image: '../works/budget-beam.png',
    live: 'https://budget-beam.onrender.com/',
    repository: 'https://github.com/Mofuhidy/budget-beam',
    technology: ['Rails', 'Tailwindcss'],
    shortDescription: 'A mobile web application for budget management: Easily track your expenses by associating transactions with specific categories, enabling you to visualize your spending habits at a glance.',
    description: 'Budget Beam a simple budget app in which any user can sign up first and then have multiple categories for his expenses. Each category has transactions. It tracks all the transactions, sum them and show them to the user..',
  }, {
    title: 'Countries Explorer',
    image: '../works/countires-Explorer.png',
    live: 'https://idyllic-dragon-59da6e.netlify.app/',
    repository: 'https://github.com/Mofuhidy/country-explorer-capstone',
    technology: ['React', 'Redux', 'Tailwindcss'],
    shortDescription: 'A single web page app for exploring countries that fetches data from the REST Countries API to allow users to get information about any country worldwide.',
    description: `A daily selection of privately personalized reads; no accounts or
            sign-ups required. has been the industry's standard dummy text
         ever since the 1500s, when an unknown printer took a standard dummy text.`,
  },
  {
    title: 'Math Magicians app',
    image: '../works/math-magicians.png',
    live: 'https://math-magicians-app-6pdl.onrender.com/',
    repository: 'https://github.com/Mofuhidy/math-magicians',
    technology: ['React', 'Tailwindcss'],
    shortDescription: '"Math magicians" is a website for all fans of mathematics. It is a Single Page App (SPA) that allows users to: Make simple calculations. Read a random math-related quote.',
    description: ' Math magicians is a website for all fans of mathematics. It is a Single Page App (SPA) that allows users to: Make simple calculations. Read a random math-related quote',
  },
  {
    title: 'ToDo list app',
    image: '../works/todolist.png',
    live: 'https://mofuhidy.github.io/to-Do-list/',
    repository: 'https://github.com/Mofuhidy/to-Do-list',
    technology: ['JS', 'HTML', 'CSS', 'Webpack'],
    shortDescription: 'To Do list is a simple HTML/CSS/JS to-do list app allows users to create and manage their tasks in a digital format.',
    description: 'To Do List is a simple HTML/CSS/JS app that allows users to create and manage their tasks in a digital format. It is a great way to stay organized and on track with your work or personal life. It allows you to Add, edit, and delete tasks and Mark tasks as complete',
  },
  {
    title: 'Awesome Books',
    image: '../works/awesome.png',
    live: 'https://mofuhidy.github.io/awesome-books-ES6/',
    repository: 'https://github.com/Mofuhidy/awesome-books-ES6',
    technology: ['JS', 'JS(ES6)', 'HTML', 'CSS'],
    shortDescription: 'is a simple website that displays a list of books and allows you to add and remove books from that list.',
    description: 'Awesome books is a simple website that displays a list of books and allows you to add and remove books from that list. using HTML, CSS, Webpack, and JavaScript(ES6)',
  },
  {
    title: '1st portfolio',
    image: '../works/firstportfolio.png',
    live: 'https://mofuhidy.vercel.app/',
    repository: 'https://github.com/Mofuhidy/my-portfolio',
    technology: ['JS', 'HTML', 'CSS'],
    shortDescription: 'This is the first portfolio I developed',
    description: 'My portfolio project is a website that I designed and developed. It features my work as a web developer and showcases my skills in HTML, CSS, and JavaScript',
  },

  {
    title: 'The Arab Youth Sustainable Development Network (AYSDN)',
    image: '../works/aysdn.png',
    live: 'https://mofuhidy.github.io/capstone-project.github.io/',
    repository: 'https://github.com/Mofuhidy/first-capstone-project',
    technology: ['Bootstrap', 'JS', 'HTML', 'CSS'],
    shortDescription: 'In this project I applied what I learned in the first module using HTML - CSS - basic JS',
    description: 'The Arab Youth Sustainable Development Network (AYSDN) is a network launched among youth professionals and experts from the MENA working on Sustainable Development Goals. The network keen to assist local government , local and international Organizations, private sectors and to support the United Nations to achieve the 17 Sustainable Development Goals in the Arab World as well as educate youth about the Sustainable Development Goals (SDGs) and provide practical volunteering opportunities, amongst other activities, to unleash their potential while being an active world citizen.',
  },

];
export default projects;
